import { myLocalStorage } from "../components/StorageHelper";

export const TENANT_USER_ROLE = "TENANT_USER";

export const getUserRole = (): string | null => myLocalStorage.getItem("role");

export const isTenantUser = (role?: string | null): boolean =>
  (role ?? getUserRole()) === TENANT_USER_ROLE;

export const isCloudAdmin = (role?: string | null): boolean => !isTenantUser(role);

const TENANT_CLOUD_HOME_PATHS: Record<string, string> = {
  aws: "/aws/users",
  azure: "/azure-directory/azureusers",
  gcp: "/gcp/gcpusers",
};

export const getTenantCloudHomePath = (cloudProvider: string): string =>
  TENANT_CLOUD_HOME_PATHS[cloudProvider.toLowerCase()] ?? "/";
